import { MessageStatus } from '@govbr-ds/react-components/dist/types/messages';
import { removeFormatCurrency } from '../../../../../../../../../utils/formatCurrency';
import { ITributoAdicionado, ITributoPossivel, ITributos } from '../../../../../../../../../interfaces/ITributos';
import { validarDeducoes } from 'utils/validarDeducoes';

export function validarCamposObrigatoriosSemBanho(
  receitaBrutaEstabelecimento: string,
  tributos: ITributoAdicionado[],
  tributosPossiveis: ITributos | undefined,
  mostrarNotificacao: (notificacao: { tipo: MessageStatus; conteudo: string }) => void
): boolean {
  if (receitaBrutaEstabelecimento === '' || removeFormatCurrency(receitaBrutaEstabelecimento) === 0) {
    mostrarNotificacao({
      tipo: 'danger',
      conteudo: 'Informe a receita bruta do estabelecimento',
    });
    return false;
  }

  let errosValidacaoDeducoes = validarDeducoes(tributos, tributosPossiveis);
  if (errosValidacaoDeducoes !== '') {
    mostrarNotificacao({
      tipo: 'danger',
      conteudo: errosValidacaoDeducoes,
    });
    return false;
  }

  return true;
}

export function validarCamposObrigatoriosComBanho(
  valorBanho: string,
  quantidade: string,
  mostrarNotificacao: (notificacao: { tipo: MessageStatus; conteudo: string }) => void
): boolean {
  if (valorBanho === '' || removeFormatCurrency(valorBanho) === 0) {
    mostrarNotificacao({
      tipo: 'danger',
      conteudo: 'Informe o valor do banho',
    });
    return false;
  }

  if (quantidade === '' || parseFloat(quantidade) === 0) {
    mostrarNotificacao({
      tipo: 'danger',
      conteudo: 'Informe a quantidade',
    });
    return false;
  }

  return true;
}
